import React, { useContext } from 'react';
import { Badge, Text } from '@chakra-ui/react';
import { FaCircle } from 'react-icons/fa';
import { StoreContext } from '../context/Store';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Availability = _ref => {
  let {
    product,
    asBubble = false
  } = _ref;
  const {
    settings,
    currentProduct
  } = useContext(StoreContext);
  const useProduct = product ? product : currentProduct;
  const {
    stock,
    reorderPossible
  } = useProduct;
  const canReorder = settings.data.purchase_to_order && reorderPossible;
  if (!settings.show_stock) {
    return null;
  }
  if (asBubble) {
    if (stock >= 5) {
      return ___EmotionJSX(FaCircle, {
        style: {
          width: '12px',
          height: '12px'
        },
        fill: "#27ae60"
      });
    }
    if (stock < 5 && stock > 0) {
      return ___EmotionJSX(FaCircle, {
        style: {
          width: '12px',
          height: '12px'
        },
        fill: "#27ae60"
      });
    }
    if (stock <= 0) {
      if (canReorder) {
        return ___EmotionJSX(FaCircle, {
          style: {
            width: '12px',
            height: '12px'
          },
          fill: "#f1c40f"
        });
      } else {
        return ___EmotionJSX(FaCircle, {
          style: {
            width: '12px',
            height: '12px'
          },
          fill: "#e74c3c"
        });
      }
    }
  } else {
    // TODO Individualisierungen

    if (useProduct.hasVariants && !useProduct.variantSelected) {
      return ___EmotionJSX(Text, null, "Bitte Variante w\xE4hlen");
    }
    if (stock >= 5) {
      return ___EmotionJSX(Badge, {
        colorScheme: "green"
      }, "Aktuell Verf\xFCgbar");
    }
    if (stock < 5 && stock > 0) {
      return ___EmotionJSX(Badge, {
        colorScheme: "green"
      }, "Aktuell Verf\xFCgbar");
    }
    if (stock <= 0) {
      if (canReorder) {
        return ___EmotionJSX(Badge, {
          colorScheme: "yellow"
        }, "Auf Bestellung");
      } else {
        return ___EmotionJSX(Badge, {
          colorScheme: "red"
        }, "Aktuell nicht verf\xFCgbar");
      }
    }
  }
};
export default Availability;